/**
 * @description: 商品退货明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-stm-report">
        <div class="tm-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="tmTime">
                        <input type="text" class="form-control laydate-icon" v-model="tmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="tmEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="tmShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="tm_stock_input" data-placeholder="请选择仓库" disabled>
                    </select>
                </div>
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="tm_admin" data-placeholder="请选择操作人"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="tmtypes" data-placeholder="请选择商品类型"></select>
                </div>
                <label class="list-label-4">订单类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择订单类型" v-model="tmOrdertype" ref="tmOrdertype" readonly @click="tmOrdertype_fun($event)">
                    <span class="selection-clear" @click="clear_input">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitTmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getTmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">退货总量:</label>
                <div class="list-total" ref="tm_quantity"></div>
                <label class="list-label-4">进货总价:</label>
                <div class="list-total" ref="tm_total"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="tmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="tmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='tmExport_allcheck' @click='tmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="time">
                            <label>退货时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="relation_id">
                            <label>订单编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="order_type">
                            <label>订单类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="store_name">
                            <label>退货仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="actual_amount">
                            <label>折后单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="actual_amount_total">
                            <label>折后价合计</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmExport_checkModel' value="buying_price_total">
                            <label>进货价合计</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='tmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='tmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 订单类型弹窗 -->
            <div class="ele-hide" ref="tmOrdertype_alert">
                <div class="sel-seldiv">
                    <ul class="set-area">
                        <li>
                            <input type='checkbox' v-model='tmOrder_allcheck' v-on:click='tmOrderCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="1">
                            <label>普通商品</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="2">
                            <label>开房套餐</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="3">
                            <label>商品套餐</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="4">
                            <label>续时套餐</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="5">
                            <label>计时开房</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="6">
                            <label>预买</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="7">
                            <label>预买续时</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="8">
                            <label>包断</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="9">
                            <label>包断续时</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="10">
                            <label>开房小吃</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='tmOrder_checkboxModel' value="12">
                            <label>限时秒杀</label>
                        </li>
                        <div style="clear:both;"></div>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                tmStartTime: "",
                tmEndTime: "",
                tmOrdertype: "",
                tmOrder_allcheck: false,
                c_tmOrder_allcheck: false,
                tmOrder_checkboxModel: [],
                tmOrder_checkboxData: [{id: "1", name: "普通商品"}, {id: "2", name: "开房套餐"}, {id: "3", name: "商品套餐"}, {id: "4", name: "续时套餐"}, {id: "5", name: "计时开房"}, {id: "6", name: "预买"}, {id: "7", name: "预买续时"}, {id: "8", name: "包断"}, {id: "9", name: "包断续时"}, {id: "10", name: "开房小吃"}, {id: "12", name: "限时秒杀"}],
                tmExport_allcheck: false,
                c_tmExport_allcheck: false,
                tmExport_checkModel: [],
                tmExport_checkData: ['time', 'relation_id', 'order_type', 'shop_name', 'room_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'store_name', 'admin_name', 'actual_amount', 'actual_amount_total', 'buying_price', 'buying_price_total'],
                tmExport_type: 1,
            }
        },
        watch: {
            tmOrdertype: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.tmOrdertype).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.tmOrdertype).parent().find('.selection-clear').hide();
                    }
                },
                deep:true
            },
            tmOrder_checkboxModel: {
                handler: function (val, oldVal) {
                    if(this.tmOrder_checkboxModel.length >= this.tmOrder_checkboxData.length) {
                        this.tmOrder_allcheck = true;
                        this.c_tmOrder_allcheck = true;
                    } else {
                        this.tmOrder_allcheck = false;
                        this.c_tmOrder_allcheck = false;
                    }
                },
                deep: true
            },
            tmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.tmExport_checkModel.length >= this.tmExport_checkData.length) {
                        this.tmExport_allcheck = true;
                        this.c_tmExport_allcheck = true;
                    } else {
                        this.tmExport_allcheck = false;
                        this.c_tmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.tmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.tmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.typeList = [];
            this.getGoodsType(); // 商品类型
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.tmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.tmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.tmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.tmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.tmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.tmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.tmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.tmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 操作人
                                _this.getAdmin(e.params.data.id);
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.tm_stock_input).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.tm_stock_input).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.tmShop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.tm_stock_input).prop("disabled", false);
                            _this.getstockdata(data.response.result[1].id);
                            // 操作人
                            _this.getAdmin($(_this.$refs.tmShop).val());
                            _this.setShopDefaultTime($(_this.$refs.tmShop).val());
                            _this.innitTmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库
            getstockdata: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.tm_stock_input).html("");
                            $(_this.$refs.tm_stock_input).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取操作人
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.tm_admin).html("");
                            $(_this.$refs.tm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品类型
            getGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {

                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            result.unshift({ id: "0", name: "全部" });
                            $.each(result, function(k, v) {
                                _this.typeList.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.tmtypes).html("");
                            $(_this.$refs.tmtypes).select2({
                                data: _this.typeList,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 清空多选
            clear_input: function() {
                this.tmOrdertype = "";
                this.tmOrder_checkboxModel = [];
            },



            // 订单类型
            tmOrdertype_fun: function(e) {
                let _this = this;
                let c_order_checkboxModel = _this.tmOrder_checkboxModel;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['订单类型', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.tmOrdertype_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.tmOrdertype != "") {
                            _this.tmOrder_checkboxModel = c_order_checkboxModel;
                            return;
                        }
                        _this.tmOrder_checkboxModel = [];
                    }
                }, function() {
                    var orderTxts = [];
                    _this.tmOrder_checkboxData.forEach(function(item) {
                        _this.tmOrder_checkboxModel.forEach(function(item2) {
                            if(item.id == item2){
                                orderTxts.push(item.name);
                            }
                        });
                    });
                    _this.tmOrdertype = orderTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.tmOrdertype != "") {
                        _this.tmOrder_checkboxModel = c_order_checkboxModel;
                        return;
                    }
                    _this.tmOrder_checkboxModel = [];
                });
            },
            // 订单类型全选
            tmOrderCheckedAll: function() {
                let _this = this;
                _this.tmOrder_allcheck = _this.c_tmOrder_allcheck;
                if(!_this.tmOrder_allcheck) { // 实现全选
                    _this.tmOrder_checkboxModel = [];
                    _this.tmOrder_checkboxData.forEach(function(item) {
                        _this.tmOrder_checkboxModel.push(item.id);
                    });
                } else { // 实现反选
                    _this.tmOrder_checkboxModel = [];
                }
            },
            // 商品退货明细报表表格
            innitTmTable: function() {
                let _this = this;
                $(_this.$refs.tmList).bootstrapTable('destroy');
                $(_this.$refs.tmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getTmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "time",
                        title: "退货时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "relation_id",
                        title: "订单编号",
                        width: "110",
                        valign: "middle"
                    }, {
                        field: "order_type",
                        title: "订单类型",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "退货数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "store_name",
                        title: "退货仓库",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "actual_amount",
                        title: "折后单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "actual_amount_total",
                        title: "折后价<br />合计",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "buying_price_total",
                        title: "进货价<br />合计",
                        width: "6%",
                        valign: "middle"
                    }],
                });
            },
            // 获取商品退货明细报表
            getTmList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.tmShop).val(),
                    store_id = $.trim($(_this.$refs.tm_stock_input).val()),
                    order_type = [],
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                if(_this.tmOrder_checkboxModel.length != '0' && _this.tmOrder_checkboxModel.length != '9') {
                    for( var i in _this.tmOrder_checkboxModel ){
                        order_type.push(_this.tmOrder_checkboxModel[i]);
                    }
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.tmStartTime,
                            "end_date": _this.tmEndTime,
                            "shop_id": shop_id,
                            "goods_type": $(_this.$refs.tmtypes).val() || '',
                            "store_id": store_id,
                            "order_type": order_type,
                            "admin_id": $.trim($(_this.$refs.tm_admin).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGoodsRefundedDetailList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                            $(_this.$refs.tm_quantity).text(data.response.result.quantity_total);
                            $(_this.$refs.tm_total).text(data.response.result.buying_price_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getTmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/detailCommonExport?bill_type=refunded"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.tmExport_checkModel = data.response.result.export_fields;
                                _this.tmExport_type = data.response.result.export_type;
                            } else {
                                _this.tmExport_checkModel = _this.tmExport_checkData;
                                _this.tmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.tmExport_alert)
                }, function() {
                    _this.exportTmList();
                });
            },
            // 导出字段全选
            tmExportCheckedAll: function() {
                let _this = this;
                _this.tmExport_allcheck = _this.c_tmExport_allcheck;
                if(!_this.tmExport_allcheck) { // 实现全选
                    _this.tmExport_checkModel = [];
                    _this.tmExport_checkData.forEach(function(item) {
                        _this.tmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.tmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportTmList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.tmShop).val(),
                    store_id = $.trim($(_this.$refs.tm_stock_input).val()),
                    order_type = [],
                    goods_type = $(_this.$refs.tmtypes).val() || '';
                let export_fields = JSON.stringify(_this.tmExport_checkModel);
                if(_this.tmOrder_checkboxModel.length != '0' && _this.tmOrder_checkboxModel.length != '9') {
                    for( var i in _this.tmOrder_checkboxModel ){
                        order_type.push(_this.tmOrder_checkboxModel[i]);
                    }
                }
                window.location.href = Vue.ctUrl + "FinanceReport/detailCommonExport?bill_type=refunded" +
                    "&start_date=" + _this.tmStartTime +
                    "&end_date=" + _this.tmEndTime +
                    "&shop_id=" + shop_id +
                    "&goods_type=" + goods_type +
                    "&store_id=" + store_id +
                    "&order_type=" + order_type +
                    "&admin_id=" + $.trim($(_this.$refs.tm_admin).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.tmExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .tm-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1500px;
                // table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>